var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoFull(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 119,
    height: 50,
    viewBox: "0 0 119 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4420",
    "data-name": "Rectangle 4420",
    width: 119,
    height: 50,
    transform: "translate(-10841 -23875)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36163",
    "data-name": "Path 36163",
    d: "M480.788,151.386h6.884v2.061h-4.651v1.889h4.394V157.4h-4.394v2.061h4.909v2.061h-7.142Z",
    transform: "translate(-480.788 -151.386)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -5.21,
    y1: 4.323,
    x2: -5.199,
    y2: 4.323,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36164",
    "data-name": "Path 36164",
    d: "M564.047,178.083a2.32,2.32,0,0,0-.9.959,1.9,1.9,0,0,0-.852-.945,2.72,2.72,0,0,0-1.3-.3,2.45,2.45,0,0,0-.716.1,2.531,2.531,0,0,0-.587.258,2.084,2.084,0,0,0-.444.358,1.739,1.739,0,0,0-.286.4h-.029v-.945h-2.061v6.956h2.147v-3.463a4.885,4.885,0,0,1,.043-.658,1.634,1.634,0,0,1,.179-.565,1.024,1.024,0,0,1,.393-.4,1.325,1.325,0,0,1,.673-.15.827.827,0,0,1,.565.172.987.987,0,0,1,.279.415,1.834,1.834,0,0,1,.1.515q.014.272.014.458v3.678h2.147v-3.678a2.738,2.738,0,0,1,.064-.6,1.4,1.4,0,0,1,.215-.5,1.025,1.025,0,0,1,.4-.336,1.421,1.421,0,0,1,.622-.122.785.785,0,0,1,.737.351,1.617,1.617,0,0,1,.208.837v4.05h2.147v-4.108a5.485,5.485,0,0,0-.122-1.181,2.722,2.722,0,0,0-.4-.959,1.932,1.932,0,0,0-.759-.644,2.658,2.658,0,0,0-1.181-.236,2.71,2.71,0,0,0-1.3.286",
    transform: "translate(-556.877 -177.797)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -9.006,
    y1: 2.88,
    x2: -8.99,
    y2: 2.88,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36165",
    "data-name": "Path 36165",
    d: "M665.211,159.512h2.147v-6.956h-2.147Zm.193-10.026a1.244,1.244,0,1,0,.88-.365,1.2,1.2,0,0,0-.88.365",
    transform: "translate(-665.039 -149.122)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -6.885,
    y1: 11.21,
    x2: -6.874,
    y2: 11.21,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36166",
    "data-name": "Path 36166",
    d: "M697.366,177.928a2.854,2.854,0,0,0-.937.422,2.2,2.2,0,0,0-.658.73,2.122,2.122,0,0,0-.25,1.059,1.855,1.855,0,0,0,.265,1.052,1.825,1.825,0,0,0,.673.608,3.607,3.607,0,0,0,.873.322l.873.2a2.908,2.908,0,0,1,.673.229.436.436,0,0,1,.265.408.4.4,0,0,1-.3.394,1.989,1.989,0,0,1-.673.107,1.794,1.794,0,0,1-.851-.193,2.159,2.159,0,0,1-.666-.565l-1.3,1.445a2.751,2.751,0,0,0,1.26.737,5.474,5.474,0,0,0,1.474.207,6.124,6.124,0,0,0,1.131-.107,3.234,3.234,0,0,0,1.031-.372,2.249,2.249,0,0,0,.751-.7,1.948,1.948,0,0,0,.294-1.109,1.858,1.858,0,0,0-.265-1.052,1.956,1.956,0,0,0-.673-.623,3.288,3.288,0,0,0-.873-.336l-.873-.2a3.482,3.482,0,0,1-.673-.215.4.4,0,0,1-.265-.379.455.455,0,0,1,.258-.444,1.171,1.171,0,0,1,.53-.129,1.52,1.52,0,0,1,1.245.587l1.317-1.3a2.577,2.577,0,0,0-1.188-.716,5.04,5.04,0,0,0-1.388-.2,4.305,4.305,0,0,0-1.073.136",
    transform: "translate(-695.348 -177.792)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -10.653,
    y1: 4.842,
    x2: -10.637,
    y2: 4.842,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36167",
    "data-name": "Path 36167",
    d: "M755.6,177.928a2.851,2.851,0,0,0-.937.422,2.2,2.2,0,0,0-.658.73,2.121,2.121,0,0,0-.25,1.059,1.856,1.856,0,0,0,.265,1.052,1.824,1.824,0,0,0,.673.608,3.605,3.605,0,0,0,.873.322l.873.2a2.91,2.91,0,0,1,.673.229.436.436,0,0,1,.265.408.4.4,0,0,1-.3.394,1.99,1.99,0,0,1-.673.107,1.8,1.8,0,0,1-.852-.193,2.161,2.161,0,0,1-.665-.565l-1.3,1.445a2.753,2.753,0,0,0,1.26.737,5.476,5.476,0,0,0,1.474.207,6.123,6.123,0,0,0,1.131-.107,3.231,3.231,0,0,0,1.03-.372,2.247,2.247,0,0,0,.752-.7,1.949,1.949,0,0,0,.294-1.109,1.859,1.859,0,0,0-.265-1.052,1.957,1.957,0,0,0-.673-.623,3.289,3.289,0,0,0-.873-.336l-.873-.2a3.489,3.489,0,0,1-.673-.215A.4.4,0,0,1,755.9,180a.455.455,0,0,1,.258-.444,1.17,1.17,0,0,1,.53-.129,1.521,1.521,0,0,1,1.245.587l1.317-1.3a2.576,2.576,0,0,0-1.188-.716,5.041,5.041,0,0,0-1.388-.2,4.307,4.307,0,0,0-1.073.136",
    transform: "translate(-753.579 -177.792)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -11.553,
    y1: 4.842,
    x2: -11.538,
    y2: 4.842,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36168",
    "data-name": "Path 36168",
    d: "M814.371,159.512h2.147v-6.956h-2.147Zm.193-10.026a1.244,1.244,0,1,0,.88-.365,1.2,1.2,0,0,0-.88.365",
    transform: "translate(-814.199 -149.122)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -8.515,
    y1: 11.209,
    x2: -8.504,
    y2: 11.209,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36169",
    "data-name": "Path 36169",
    d: "M848.492,182.715a2.025,2.025,0,0,1,0-2.548,1.892,1.892,0,0,1,2.533,0,2.025,2.025,0,0,1,0,2.548,1.891,1.891,0,0,1-2.533,0m-.243-4.666a3.635,3.635,0,0,0-1.231.737,3.458,3.458,0,0,0-.823,1.152,3.907,3.907,0,0,0,0,3.005,3.454,3.454,0,0,0,.823,1.152,3.631,3.631,0,0,0,1.231.737,4.555,4.555,0,0,0,3.02,0,3.632,3.632,0,0,0,1.231-.737,3.457,3.457,0,0,0,.823-1.152,3.906,3.906,0,0,0,0-3.005,3.461,3.461,0,0,0-.823-1.152,3.636,3.636,0,0,0-1.231-.737,4.553,4.553,0,0,0-3.02,0",
    transform: "translate(-845.894 -177.792)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -13.067,
    y1: 3.847,
    x2: -13.052,
    y2: 3.847,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36170",
    "data-name": "Path 36170",
    d: "M928.281,177.9a2.53,2.53,0,0,0-.587.258,2.081,2.081,0,0,0-.444.358,1.742,1.742,0,0,0-.286.4h-.029v-.945h-2.061v6.956h2.147v-3.463a4.885,4.885,0,0,1,.043-.658,1.64,1.64,0,0,1,.179-.565,1.025,1.025,0,0,1,.394-.4,1.325,1.325,0,0,1,.673-.15.923.923,0,0,1,.966.615,1.964,1.964,0,0,1,.129.594q.021.322.021.622v3.406h2.147v-3.836a7.944,7.944,0,0,0-.1-1.3,2.809,2.809,0,0,0-.379-1.045,1.905,1.905,0,0,0-.78-.694A2.958,2.958,0,0,0,929,177.8a2.451,2.451,0,0,0-.716.1",
    transform: "translate(-924.875 -177.797)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -14.588,
    y1: 4.369,
    x2: -14.573,
    y2: 4.369,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36171",
    "data-name": "Path 36171",
    d: "M995.436,177.928a2.855,2.855,0,0,0-.937.422,2.2,2.2,0,0,0-.658.73,2.12,2.12,0,0,0-.25,1.059,1.855,1.855,0,0,0,.265,1.052,1.824,1.824,0,0,0,.673.608,3.606,3.606,0,0,0,.873.322l.873.2a2.911,2.911,0,0,1,.673.229.436.436,0,0,1,.265.408.4.4,0,0,1-.3.394,1.989,1.989,0,0,1-.673.107,1.8,1.8,0,0,1-.852-.193,2.158,2.158,0,0,1-.665-.565l-1.3,1.445a2.751,2.751,0,0,0,1.259.737,5.476,5.476,0,0,0,1.474.207,6.123,6.123,0,0,0,1.131-.107,3.233,3.233,0,0,0,1.031-.372,2.248,2.248,0,0,0,.751-.7,1.949,1.949,0,0,0,.294-1.109,1.858,1.858,0,0,0-.265-1.052,1.955,1.955,0,0,0-.672-.623,3.291,3.291,0,0,0-.873-.336l-.873-.2a3.489,3.489,0,0,1-.673-.215.4.4,0,0,1-.265-.379.456.456,0,0,1,.258-.444,1.17,1.17,0,0,1,.529-.129,1.52,1.52,0,0,1,1.245.587l1.317-1.3a2.577,2.577,0,0,0-1.188-.716,5.039,5.039,0,0,0-1.388-.2,4.306,4.306,0,0,0-1.073.136",
    transform: "translate(-993.418 -177.792)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -15.261,
    y1: 4.842,
    x2: -15.245,
    y2: 4.842,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36172",
    "data-name": "Path 36172",
    d: "M23.572,47.912c-.152-.007-.3-.014-.454-.025A22.223,22.223,0,0,1,7.684,40.159q-.117-.137-.23-.274A23.122,23.122,0,0,1,2.068,25,22.715,22.715,0,0,1,24.508,2.07,22.491,22.491,0,0,1,45.46,16.794a22.83,22.83,0,0,1,.819,2.644A23.5,23.5,0,0,1,46.143,31.1a.394.394,0,0,0-.188-.043l-.232,0a.425.425,0,0,1-.43-.421L45.282,29.5a.426.426,0,0,0-.425-.423h0a.424.424,0,0,1-.43-.412l-.1-3.071-.185,0-.013,3.068a.427.427,0,0,1-.421.425l-1.036.01a.423.423,0,0,0-.421.43l.01,1.136a.426.426,0,0,1-.421.43l-1.337.013a1.6,1.6,0,0,0-1.579,1.611l.038,3.644a.429.429,0,0,1-.423.431L25.5,36.927a.433.433,0,0,1-.269-.091l-.551-.437a.428.428,0,0,0-.269-.093l-6.4.065a.425.425,0,0,0-.394.578l.434,1.135a33.58,33.58,0,0,1,5.43.366c2.928.426,6.552.949,10.293,1.308,2.52.245,5.094.412,7.542.427-.077.09-.155.178-.234.266a.244.244,0,0,0-.019.022A22.691,22.691,0,0,1,36.155,44.6a22.043,22.043,0,0,1-11.647,3.326q-.471,0-.936-.019M24.508,0A24.112,24.112,0,0,0,7.17,7.33a25.358,25.358,0,0,0,0,35.339A24.112,24.112,0,0,0,24.508,50c.554,0,1.109-.019,1.659-.058q.369-.026.735-.062a24.093,24.093,0,0,0,10.346-3.518,24.675,24.675,0,0,0,5.383-4.533q.736-.821,1.389-1.7c.132-.174.26-.353.386-.533A25.274,25.274,0,0,0,49.016,25a25.909,25.909,0,0,0-.182-3.08A25.095,25.095,0,0,0,41.845,7.33,24.1,24.1,0,0,0,24.508,0Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 0.106,
    y1: 0.906,
    x2: 0.108,
    y2: 0.906,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#009245"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491,
    stopColor: "#89cc50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48b14b"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36173",
    "data-name": "Path 36173",
    d: "M18.175,41.117A23.122,23.122,0,0,0,23.56,56a46.666,46.666,0,0,1,9.2-1.742A19.03,19.03,0,0,1,61.567,32.911,22.491,22.491,0,0,0,40.615,18.187a22.715,22.715,0,0,0-22.44,22.93",
    transform: "translate(-18.175 -18.187)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -0.048,
    y1: 1.267,
    x2: -0.045,
    y2: 1.267,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36174",
    "data-name": "Path 36174",
    d: "M76.1,334.631c-.356.007-.7.017-1.049.038-.12.006-.24.013-.359.022a46.665,46.665,0,0,0-9.2,1.742q.113.137.23.274a22.223,22.223,0,0,0,15.434,7.729c.151.01.3.017.454.025q.465.019.936.019A22.043,22.043,0,0,0,94.2,341.152a22.693,22.693,0,0,0,4.914-4.132.245.245,0,0,1,.019-.022c.08-.088.158-.177.234-.266-2.447-.015-5.022-.182-7.542-.427-3.741-.359-7.365-.883-10.293-1.308a34.1,34.1,0,0,0-4.907-.371q-.264,0-.524,0",
    transform: "translate(-65.498 -334.626)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: -1.936,
    y1: 0.706,
    x2: -1.924,
    y2: 0.706,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00008b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a1a1a"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36175",
    "data-name": "Path 36175",
    d: "M81.46,155.369v1.975h4.951l-5.137,6.093V165.5h8.011v-2.061H84.079l5.035-6.093v-1.975Z",
    transform: "translate(-81.274 -155.369)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: -1.047,
    y1: 3.08,
    x2: -1.034,
    y2: 3.08,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#009245"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89cc50"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36176",
    "data-name": "Path 36176",
    d: "M163.127,184.133a1.3,1.3,0,0,1,.3-.414,1.513,1.513,0,0,1,.465-.294,1.6,1.6,0,0,1,.63-.116,1.279,1.279,0,0,1,.958.387,1.243,1.243,0,0,1,.357.929h-2.832a1.313,1.313,0,0,1,.121-.492m.085-2.11a3.61,3.61,0,0,0-1.229.737,3.432,3.432,0,0,0-.824,1.151,3.9,3.9,0,0,0,0,3,3.457,3.457,0,0,0,.824,1.151,3.628,3.628,0,0,0,1.229.736,4.369,4.369,0,0,0,1.51.258,3.9,3.9,0,0,0,1.631-.357,3.412,3.412,0,0,0,1.3-1.017l-1.5-1.1a2.411,2.411,0,0,1-.638.608,1.624,1.624,0,0,1-.894.236,1.578,1.578,0,0,1-1.058-.365,1.692,1.692,0,0,1-.558-.98h4.978v-.674a4.6,4.6,0,0,0-.231-1.5,3.3,3.3,0,0,0-.65-1.151,2.81,2.81,0,0,0-1.03-.737,3.416,3.416,0,0,0-1.352-.259,4.372,4.372,0,0,0-1.51.259",
    transform: "translate(-160.858 -181.764)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: -2.406,
    y1: 3.839,
    x2: -2.391,
    y2: 3.839,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36177",
    "data-name": "Path 36177",
    d: "M237.913,182.086a2.629,2.629,0,0,0-.816.967h-.03v-1.117h-2.145v6.955h2.145v-2.905a6.791,6.791,0,0,1,.059-.944,1.775,1.775,0,0,1,.249-.736,1.287,1.287,0,0,1,.55-.48,2.263,2.263,0,0,1,.975-.172,2.864,2.864,0,0,1,.464.036,3.212,3.212,0,0,1,.452.108v-1.961a1.9,1.9,0,0,0-.344-.057c-.124-.009-.248-.015-.372-.015a2.072,2.072,0,0,0-1.188.322",
    transform: "translate(-234.923 -181.764)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: -5.02,
    y1: 3.985,
    x2: -4.998,
    y2: 3.985,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36178",
    "data-name": "Path 36178",
    d: "M284.159,186.687a2.027,2.027,0,0,1,0-2.548,1.892,1.892,0,0,1,2.533,0,2.032,2.032,0,0,1,0,2.548,1.9,1.9,0,0,1-2.533,0m-.244-4.664a3.626,3.626,0,0,0-1.231.737,3.448,3.448,0,0,0-.822,1.151,3.9,3.9,0,0,0,0,3,3.473,3.473,0,0,0,.822,1.151,3.645,3.645,0,0,0,1.231.736,4.551,4.551,0,0,0,3.018,0,3.639,3.639,0,0,0,1.232-.736,3.451,3.451,0,0,0,.821-1.151,3.888,3.888,0,0,0,0-3,3.427,3.427,0,0,0-.821-1.151,3.62,3.62,0,0,0-1.232-.737,4.53,4.53,0,0,0-3.018,0",
    transform: "translate(-281.561 -181.764)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: -3.919,
    y1: 3.825,
    x2: -3.905,
    y2: 3.825,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36179",
    "data-name": "Path 36179",
    d: "M479.474,261.619a1.175,1.175,0,0,0,1.211,1.319,1.039,1.039,0,0,0,1.118-.836h-.564a.516.516,0,0,1-.53.4c-.5,0-.656-.462-.656-.9,0-.472.178-.888.641-.888a.508.508,0,0,1,.546.4h.561a.993.993,0,0,0-1.088-.839,1.223,1.223,0,0,0-1.238,1.347",
    transform: "translate(-479.474 -260.272)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: -20.27,
    y1: 8.615,
    x2: -20.228,
    y2: 8.615,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36180",
    "data-name": "Path 36180",
    d: "M502.514,259.263v2.745h.539v-1.033c0-.3.059-.523.358-.523.226,0,.316.134.316.387v1.168h.536v-1.249c0-.528-.289-.743-.652-.743a.624.624,0,0,0-.558.275v-1.028Z",
    transform: "translate(-502.514 -259.263)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: -20.557,
    y1: 11.318,
    x2: -20.516,
    y2: 11.318,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36181",
    "data-name": "Path 36181",
    d: "M520.8,267.275c0-.188.121-.287.445-.287h.22v.051c0,.257-.042.5-.385.5a.25.25,0,0,1-.28-.259m-.45-.77h.512c.025-.141.074-.237.3-.237.25,0,.3.136.3.274v.119h-.278c-.571,0-.927.2-.927.648a.6.6,0,0,0,.667.61.573.573,0,0,0,.547-.235.788.788,0,0,0,.027.19h.515a4.437,4.437,0,0,1-.026-.5v-.818c0-.463-.284-.667-.805-.67h-.01c-.584,0-.8.279-.824.622",
    transform: "translate(-520.264 -265.883)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: -28.822,
    y1: 11.075,
    x2: -28.767,
    y2: 11.075,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36182",
    "data-name": "Path 36182",
    d: "M539.138,266.622c0-.1-.007-.3-.014-.342h-.529c0,.163,0,.334,0,.528v1.418h.539v-.849c0-.534.233-.707.624-.7v-.4a.6.6,0,0,0-.624.342",
    transform: "translate(-538.595 -266.28)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: -31.154,
    y1: 16.357,
    x2: -31.096,
    y2: 16.357,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36183",
    "data-name": "Path 36183",
    d: "M699.034,266.622c0-.1-.007-.3-.014-.342h-.528c0,.163,0,.334,0,.528v1.418h.539v-.849c0-.534.233-.707.625-.7v-.4a.6.6,0,0,0-.625.342",
    transform: "translate(-698.491 -266.28)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: -40.463,
    y1: 16.357,
    x2: -40.405,
    y2: 16.357,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36184",
    "data-name": "Path 36184",
    d: "M827.633,266.622c0-.1-.007-.3-.014-.342h-.529c0,.163,0,.334,0,.528v1.418h.539v-.849c0-.534.233-.707.625-.7v-.4a.6.6,0,0,0-.625.342",
    transform: "translate(-827.09 -266.28)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: -47.95,
    y1: 16.356,
    x2: -47.892,
    y2: 16.356,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36185",
    "data-name": "Path 36185",
    d: "M972.531,266.622c0-.1-.007-.3-.014-.342h-.529c0,.163,0,.334,0,.528v1.418h.539v-.849c0-.534.233-.707.625-.7v-.4a.6.6,0,0,0-.625.342",
    transform: "translate(-971.988 -266.28)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: -56.386,
    y1: 16.354,
    x2: -56.328,
    y2: 16.354,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36186",
    "data-name": "Path 36186",
    d: "M551.538,261.648v.527h-.3v.405h.3V263.6c0,.341.125.544.505.544a1.228,1.228,0,0,0,.362-.037v-.371a.966.966,0,0,1-.123.006c-.16,0-.206-.058-.206-.205v-.961h.381v-.405h-.381v-.527Z",
    transform: "translate(-551.238 -261.648)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: -24.752,
    y1: 15.829,
    x2: -24.706,
    y2: 15.829,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-26"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4389",
    "data-name": "Rectangle 4389",
    width: 0.538,
    height: 1.946,
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: -32.592,
    y1: 34.44,
    x2: -32.534,
    y2: 34.44,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-27"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36187",
    "data-name": "Path 36187",
    d: "M564.844,259.258a.241.241,0,0,0,0,.481h.057a.241.241,0,1,0,0-.481Z",
    transform: "translate(-564.603 -259.258)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: -132.524,
    y1: 37.916,
    x2: -132.289,
    y2: 37.916,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36188",
    "data-name": "Path 36188",
    d: "M1009.741,259.258a.241.241,0,0,0,0,.481h.057a.241.241,0,1,0,0-.481Z",
    transform: "translate(-1009.5 -259.258)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: -236.904,
    y1: 37.916,
    x2: -236.669,
    y2: 37.916,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-29"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36189",
    "data-name": "Path 36189",
    d: "M572.638,266.176a2.277,2.277,0,0,0-.021-.248h-.522c0,.144,0,.325,0,.49v1.456h.539V266.79c0-.344.131-.471.36-.471s.311.159.311.377v1.178h.539v-1.238c0-.489-.254-.753-.645-.753a.594.594,0,0,0-.565.293",
    transform: "translate(-572.095 -265.883)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: -32.424,
    y1: 11.114,
    x2: -32.367,
    y2: 11.114,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-30"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36190",
    "data-name": "Path 36190",
    d: "M589.787,266.884c0-.389.184-.569.417-.569.342,0,.4.225.4.552s-.087.549-.411.549c-.238,0-.406-.2-.406-.533m-.553.024a.838.838,0,0,0,.8.943.576.576,0,0,0,.548-.273v.093c0,.382-.066.595-.416.595a.31.31,0,0,1-.344-.225h-.549c.018.22.159.617.869.617.737,0,.968-.4.968-1.02v-1.151c0-.187,0-.385,0-.558h-.511c0,.032-.017.15-.021.2-.029-.091-.169-.248-.5-.248a.914.914,0,0,0-.851,1.025",
    transform: "translate(-589.234 -265.883)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: -23.89,
    y1: 10.136,
    x2: -23.85,
    y2: 10.136,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-31"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36191",
    "data-name": "Path 36191",
    d: "M617.481,267.275c0-.188.121-.287.445-.287h.22v.051c0,.257-.042.5-.385.5a.25.25,0,0,1-.28-.259m-.45-.77h.512c.025-.141.074-.237.3-.237.25,0,.3.136.3.274v.119h-.278c-.571,0-.927.2-.927.648a.6.6,0,0,0,.667.61.573.573,0,0,0,.547-.235.788.788,0,0,0,.027.19h.515a4.393,4.393,0,0,1-.026-.5v-.818c0-.463-.284-.667-.805-.67h-.01c-.584,0-.8.279-.824.622",
    transform: "translate(-616.941 -265.883)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: -34.191,
    y1: 11.075,
    x2: -34.136,
    y2: 11.075,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-32"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36192",
    "data-name": "Path 36192",
    d: "M643.482,266.916a.89.89,0,0,0,.917,1,.81.81,0,0,0,.875-.674h-.529a.331.331,0,0,1-.333.255c-.236,0-.383-.189-.383-.6,0-.377.139-.593.386-.593a.3.3,0,0,1,.334.269h.526a.769.769,0,0,0-.849-.691.945.945,0,0,0-.943,1.033",
    transform: "translate(-643.482 -265.883)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: -35.67,
    y1: 10.864,
    x2: -35.614,
    y2: 10.864,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-33"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36193",
    "data-name": "Path 36193",
    d: "M661.944,266.9c0-.411.163-.6.413-.6.268,0,.418.193.418.6,0,.371-.147.593-.41.593s-.421-.222-.421-.6m-.547.007a.964.964,0,1,0,.981-1.025.941.941,0,0,0-.981,1.025",
    transform: "translate(-661.397 -265.883)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: -36.68,
    y1: 10.155,
    x2: -36.624,
    y2: 10.155,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-34"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36194",
    "data-name": "Path 36194",
    d: "M681.666,266.28v1.036c0,.385-.1.516-.347.516s-.3-.178-.3-.392v-1.16h-.539v1.268c0,.483.253.724.65.724a.555.555,0,0,0,.536-.27c0,.068.007.172.015.225h.528c0-.174,0-.378,0-.566V266.28Z",
    transform: "translate(-680.48 -266.28)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: -38.578,
    y1: 11.234,
    x2: -38.522,
    y2: 11.234,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-35"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36195",
    "data-name": "Path 36195",
    d: "M710.009,266.473c0,.275.1.471.738.627.279.068.362.117.362.242s-.072.189-.271.189a.337.337,0,0,1-.368-.242h-.53c.043.345.287.63.878.63s.839-.293.839-.616c0-.285-.092-.508-.741-.659-.316-.074-.376-.12-.376-.217s.058-.166.236-.166c.253,0,.3.136.319.208h.512c-.017-.264-.217-.586-.807-.586s-.79.3-.79.59",
    transform: "translate(-709.94 -265.883)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: -39.352,
    y1: 11.321,
    x2: -39.296,
    y2: 11.321,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-36"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36196",
    "data-name": "Path 36196",
    d: "M727.888,266.268c.263,0,.353.191.357.417h-.74c.021-.239.125-.417.383-.417m-.938.661a.9.9,0,0,0,.919.99.853.853,0,0,0,.893-.63h-.539a.307.307,0,0,1-.34.208c-.268,0-.39-.238-.391-.481h1.285a1.213,1.213,0,0,0,.007-.164.86.86,0,0,0-.9-.97.918.918,0,0,0-.938,1.047",
    transform: "translate(-726.951 -265.883)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: -40.309,
    y1: 10.63,
    x2: -40.253,
    y2: 10.63,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-37"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36197",
    "data-name": "Path 36197",
    d: "M752.593,261.648v.527h-.3v.405h.3V263.6c0,.341.125.544.505.544a1.229,1.229,0,0,0,.362-.037v-.371a.968.968,0,0,1-.123.006c-.161,0-.206-.058-.206-.205v-.961h.381v-.405h-.381v-.527Z",
    transform: "translate(-752.293 -261.648)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: -33.873,
    y1: 15.831,
    x2: -33.828,
    y2: 15.831,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-38"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36198",
    "data-name": "Path 36198",
    d: "M765.164,266.9c0-.411.163-.6.413-.6.268,0,.418.193.418.6,0,.371-.146.593-.41.593s-.421-.222-.421-.6m-.547.007a.964.964,0,1,0,.981-1.025.94.94,0,0,0-.981,1.025",
    transform: "translate(-764.617 -265.883)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: -42.409,
    y1: 10.156,
    x2: -42.353,
    y2: 10.156,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-39"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36199",
    "data-name": "Path 36199",
    d: "M791.835,266.916a.89.89,0,0,0,.917,1,.81.81,0,0,0,.875-.674h-.53a.331.331,0,0,1-.332.255c-.236,0-.384-.189-.384-.6,0-.377.14-.593.386-.593a.3.3,0,0,1,.333.269h.526a.769.769,0,0,0-.849-.691.945.945,0,0,0-.943,1.033",
    transform: "translate(-791.835 -265.883)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: -43.907,
    y1: 10.864,
    x2: -43.852,
    y2: 10.864,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-40"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36200",
    "data-name": "Path 36200",
    d: "M809.78,267.275c0-.188.12-.287.445-.287h.22v.051c0,.257-.042.5-.385.5a.25.25,0,0,1-.28-.259m-.45-.77h.512c.025-.141.075-.237.3-.237.25,0,.3.136.3.274v.119h-.278c-.571,0-.927.2-.927.648a.6.6,0,0,0,.667.61.573.573,0,0,0,.547-.235.8.8,0,0,0,.027.19H811a4.4,4.4,0,0,1-.026-.5v-.818c0-.463-.284-.667-.805-.67h-.01c-.584,0-.8.279-.825.622",
    transform: "translate(-809.24 -265.883)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: -44.871,
    y1: 11.076,
    x2: -44.815,
    y2: 11.076,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-41"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36201",
    "data-name": "Path 36201",
    d: "M840.282,261.045c0-.4.109-.6.417-.6.291,0,.411.238.411.562,0,.368-.144.614-.417.614-.314,0-.411-.252-.411-.579m-.514-1.782v2.108c0,.211,0,.426,0,.637h.515a.956.956,0,0,0,.021-.185.529.529,0,0,0,.511.23c.56,0,.846-.5.846-1.053s-.264-.984-.794-.984a.61.61,0,0,0-.557.252v-1.005Z",
    transform: "translate(-839.764 -259.263)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: -33.927,
    y1: 10.483,
    x2: -33.886,
    y2: 10.483,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-42"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36202",
    "data-name": "Path 36202",
    d: "M858.837,266.9c0-.411.163-.6.413-.6.268,0,.418.193.418.6,0,.371-.146.593-.41.593s-.421-.222-.421-.6m-.547.007a.964.964,0,1,0,.981-1.025.94.94,0,0,0-.981,1.025",
    transform: "translate(-858.29 -265.883)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: -47.608,
    y1: 10.156,
    x2: -47.553,
    y2: 10.156,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-43"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36203",
    "data-name": "Path 36203",
    d: "M878.267,266.176a2.293,2.293,0,0,0-.021-.248h-.522c0,.144,0,.325,0,.49v1.456h.539V266.79c0-.344.131-.471.36-.471s.31.159.31.377v1.178h.539v-1.238c0-.489-.254-.753-.645-.753a.594.594,0,0,0-.565.293",
    transform: "translate(-877.724 -265.883)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: -49.779,
    y1: 11.114,
    x2: -49.723,
    y2: 11.114,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36204",
    "data-name": "Path 36204",
    d: "M905.129,266.176a2.324,2.324,0,0,0-.021-.248h-.522c0,.144,0,.325,0,.49v1.456h.539V266.79c0-.344.131-.471.36-.471s.311.159.311.377v1.178h.539v-1.238c0-.489-.254-.753-.645-.753a.594.594,0,0,0-.565.293",
    transform: "translate(-904.586 -265.883)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: -51.305,
    y1: 11.114,
    x2: -51.248,
    y2: 11.114,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-45"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36205",
    "data-name": "Path 36205",
    d: "M923.061,266.268c.263,0,.353.191.357.417h-.74c.022-.239.125-.417.384-.417m-.937.661a.9.9,0,0,0,.919.99.853.853,0,0,0,.893-.63H923.4a.307.307,0,0,1-.34.208c-.268,0-.39-.238-.391-.481h1.285a1.193,1.193,0,0,0,.007-.164.86.86,0,0,0-.9-.97.918.918,0,0,0-.938,1.047",
    transform: "translate(-922.124 -265.883)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: -51.145,
    y1: 10.63,
    x2: -51.09,
    y2: 10.63,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-46"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36206",
    "data-name": "Path 36206",
    d: "M941.666,266.28v1.036c0,.385-.1.516-.347.516s-.3-.178-.3-.392v-1.16h-.539v1.268c0,.483.253.724.65.724a.555.555,0,0,0,.536-.27c0,.068.007.172.015.225h.528c0-.174,0-.378,0-.566V266.28Z",
    transform: "translate(-940.48 -266.28)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: -53.345,
    y1: 11.234,
    x2: -53.288,
    y2: 11.234,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-47"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36207",
    "data-name": "Path 36207",
    d: "M958.967,261.648v.527h-.3v.405h.3V263.6c0,.341.125.544.505.544a1.228,1.228,0,0,0,.362-.037v-.371a.964.964,0,0,1-.123.006c-.161,0-.206-.058-.206-.205v-.961h.381v-.405h-.381v-.527Z",
    transform: "translate(-958.667 -261.648)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: -43.236,
    y1: 15.83,
    x2: -43.191,
    y2: 15.83,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-48"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36208",
    "data-name": "Path 36208",
    d: "M984.071,267.275c0-.188.121-.287.445-.287h.22v.051c0,.257-.042.5-.385.5a.25.25,0,0,1-.28-.259m-.45-.77h.512c.025-.141.075-.237.3-.237.25,0,.3.136.3.274v.119h-.278c-.571,0-.927.2-.927.648a.6.6,0,0,0,.667.61.573.573,0,0,0,.547-.235.8.8,0,0,0,.027.19h.515a4.356,4.356,0,0,1-.026-.5v-.818c0-.463-.284-.667-.805-.67h-.01c-.584,0-.8.279-.825.622",
    transform: "translate(-983.531 -265.883)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: -54.55,
    y1: 11.074,
    x2: -54.495,
    y2: 11.074,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-49"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4413",
    "data-name": "Rectangle 4413",
    width: 0.539,
    height: 2.745,
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: -41.074,
    y1: 34.758,
    x2: -41.032,
    y2: 34.758,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: -58.56,
    y1: 34.439,
    x2: -58.501,
    y2: 34.439,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-51"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36209",
    "data-name": "Path 36209",
    d: "M1017.284,261.648v.527h-.3v.405h.3V263.6c0,.341.125.544.505.544a1.227,1.227,0,0,0,.362-.037v-.371a.965.965,0,0,1-.123.006c-.161,0-.206-.058-.206-.205v-.961h.381v-.405h-.381v-.527Z",
    transform: "translate(-1016.984 -261.648)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: -45.882,
    y1: 15.832,
    x2: -45.836,
    y2: 15.832,
    xlinkHref: "#linear-gradient-13"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-52"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36210",
    "data-name": "Path 36210",
    d: "M1030.722,266.28c-.232.818-.346,1.254-.388,1.451h0c-.031-.18-.206-.779-.407-1.451h-.578l.708,2.006a.34.34,0,0,1-.371.284c-.044,0-.1,0-.139-.008v.433a2.492,2.492,0,0,0,.252.015c.468,0,.623-.167.809-.727l.654-2Z",
    transform: "translate(-1029.345 -266.28)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: -42.555,
    y1: 9.986,
    x2: -42.514,
    y2: 9.986,
    xlinkHref: "#linear-gradient-13"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_30",
    "data-name": "Mask Group 30",
    transform: "translate(10841 23875)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7373",
    "data-name": "Group 7373",
    transform: "translate(-10841 -23875)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7270",
    "data-name": "Group 7270",
    transform: "translate(54.711 17.227)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7269",
    "data-name": "Group 7269",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4364",
    "data-name": "Rectangle 4364",
    width: 10.207,
    height: 7.248,
    transform: "translate(-0.106 10.132) rotate(-89.399)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7272",
    "data-name": "Group 7272",
    transform: "translate(63.37 20.232)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7271",
    "data-name": "Group 7271",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4365",
    "data-name": "Rectangle 4365",
    width: 7.242,
    height: 11.008,
    transform: "translate(-0.075 7.127) rotate(-89.399)",
    fill: "url(#linear-gradient-2)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7274",
    "data-name": "Group 7274",
    transform: "translate(75.678 16.969)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7273",
    "data-name": "Group 7273",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4366",
    "data-name": "Rectangle 4366",
    width: 10.416,
    height: 2.599,
    transform: "translate(-0.109 10.389) rotate(-89.399)",
    fill: "url(#linear-gradient-3)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7276",
    "data-name": "Group 7276",
    transform: "translate(79.127 20.232)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7275",
    "data-name": "Group 7275",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4367",
    "data-name": "Rectangle 4367",
    width: 7.361,
    height: 6.016,
    transform: "matrix(0.01, -1, 1, 0.01, -0.077, 7.298)",
    fill: "url(#linear-gradient-4)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7278",
    "data-name": "Group 7278",
    transform: "translate(85.753 20.232)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7277",
    "data-name": "Group 7277",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4368",
    "data-name": "Rectangle 4368",
    width: 7.361,
    height: 6.016,
    transform: "matrix(0.01, -1, 1, 0.01, -0.077, 7.298)",
    fill: "url(#linear-gradient-5)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7280",
    "data-name": "Group 7280",
    transform: "translate(92.652 16.969)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7279",
    "data-name": "Group 7279",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4369",
    "data-name": "Rectangle 4369",
    width: 10.416,
    height: 2.599,
    transform: "matrix(0.01, -1, 1, 0.01, -0.109, 10.389)",
    fill: "url(#linear-gradient-6)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7282",
    "data-name": "Group 7282",
    transform: "translate(96.258 20.232)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7281",
    "data-name": "Group 7281",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4370",
    "data-name": "Rectangle 4370",
    width: 7.38,
    height: 7.805,
    transform: "matrix(0.01, -1, 1, 0.01, -0.077, 7.298)",
    fill: "url(#linear-gradient-7)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7284",
    "data-name": "Group 7284",
    transform: "translate(105.246 20.232)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7283",
    "data-name": "Group 7283",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4371",
    "data-name": "Rectangle 4371",
    width: 7.197,
    height: 6.772,
    transform: "translate(-0.075 7.127) rotate(-89.399)",
    fill: "url(#linear-gradient-8)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7286",
    "data-name": "Group 7286",
    transform: "translate(113.046 20.232)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7285",
    "data-name": "Group 7285",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4372",
    "data-name": "Rectangle 4372",
    width: 7.361,
    height: 6.016,
    transform: "translate(-0.077 7.298) rotate(-89.399)",
    fill: "url(#linear-gradient-9)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7288",
    "data-name": "Group 7288"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7287",
    "data-name": "Group 7287",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4373",
    "data-name": "Rectangle 4373",
    width: 62.25,
    height: 61.6,
    transform: "translate(-14.113 45.635) rotate(-72.815)",
    fill: "url(#linear-gradient-10)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7290",
    "data-name": "Group 7290",
    transform: "translate(2.068 2.07)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7289",
    "data-name": "Group 7289",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4374",
    "data-name": "Rectangle 4374",
    width: 43.392,
    height: 37.815,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-11)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7292",
    "data-name": "Group 7292",
    transform: "translate(7.453 38.079)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7291",
    "data-name": "Group 7291",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4375",
    "data-name": "Rectangle 4375",
    width: 10.013,
    height: 33.915,
    transform: "translate(-0.047 9.852) rotate(-89.727)",
    fill: "url(#linear-gradient-12)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7294",
    "data-name": "Group 7294",
    transform: "translate(9.249 17.68)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7293",
    "data-name": "Group 7293",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4376",
    "data-name": "Rectangle 4376",
    width: 8.569,
    height: 10.564,
    transform: "translate(-0.569 0.032) rotate(-3.225)",
    fill: "url(#linear-gradient-13)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7296",
    "data-name": "Group 7296",
    transform: "translate(18.305 20.684)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7295",
    "data-name": "Group 7295",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4377",
    "data-name": "Rectangle 4377",
    width: 7.525,
    height: 7.686,
    transform: "matrix(0.998, -0.056, 0.056, 0.998, -0.41, 0.023)",
    fill: "url(#linear-gradient-14)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7298",
    "data-name": "Group 7298",
    transform: "translate(26.733 20.684)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7297",
    "data-name": "Group 7297",
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4378",
    "data-name": "Rectangle 4378",
    width: 5.286,
    height: 7.39,
    transform: "translate(-0.4 0.023) rotate(-3.225)",
    fill: "url(#linear-gradient-15)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7300",
    "data-name": "Group 7300",
    transform: "translate(32.04 20.684)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7299",
    "data-name": "Group 7299",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4379",
    "data-name": "Rectangle 4379",
    width: 8.125,
    height: 7.72,
    transform: "translate(-0.41 0.023) rotate(-3.225)",
    fill: "url(#linear-gradient-16)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7302",
    "data-name": "Group 7302",
    transform: "translate(54.562 29.618)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7301",
    "data-name": "Group 7301",
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4380",
    "data-name": "Rectangle 4380",
    width: 2.683,
    height: 2.347,
    transform: "translate(-0.019 2.667) rotate(-89.596)",
    fill: "url(#linear-gradient-17)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7304",
    "data-name": "Group 7304",
    transform: "translate(57.184 29.503)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7303",
    "data-name": "Group 7303",
    clipPath: "url(#clip-path-19)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4381",
    "data-name": "Rectangle 4381",
    width: 2.757,
    height: 1.768,
    transform: "matrix(0.007, -1, 1, 0.007, -0.019, 2.745)",
    fill: "url(#linear-gradient-18)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7306",
    "data-name": "Group 7306",
    transform: "translate(59.203 30.256)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7305",
    "data-name": "Group 7305",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4382",
    "data-name": "Rectangle 4382",
    width: 2.049,
    height: 1.771,
    transform: "translate(-0.014 2.037) rotate(-89.597)",
    fill: "url(#linear-gradient-19)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7308",
    "data-name": "Group 7308",
    transform: "translate(61.289 30.301)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7307",
    "data-name": "Group 7307",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4383",
    "data-name": "Rectangle 4383",
    width: 1.955,
    height: 1.181,
    transform: "matrix(0.007, -1, 1, 0.007, -0.014, 1.946)",
    fill: "url(#linear-gradient-20)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7310",
    "data-name": "Group 7310",
    transform: "translate(79.485 30.301)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7309",
    "data-name": "Group 7309",
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4384",
    "data-name": "Rectangle 4384",
    width: 1.955,
    height: 1.181,
    transform: "translate(-0.014 1.946) rotate(-89.596)",
    fill: "url(#linear-gradient-21)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7312",
    "data-name": "Group 7312",
    transform: "translate(94.119 30.301)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7311",
    "data-name": "Group 7311",
    clipPath: "url(#clip-path-23)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4385",
    "data-name": "Rectangle 4385",
    width: 1.955,
    height: 1.181,
    transform: "matrix(0.007, -1, 1, 0.007, -0.014, 1.946)",
    fill: "url(#linear-gradient-22)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7314",
    "data-name": "Group 7314",
    transform: "translate(110.607 30.301)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7313",
    "data-name": "Group 7313",
    clipPath: "url(#clip-path-24)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4386",
    "data-name": "Rectangle 4386",
    width: 1.955,
    height: 1.181,
    transform: "translate(-0.014 1.946) rotate(-89.596)",
    fill: "url(#linear-gradient-23)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7316",
    "data-name": "Group 7316",
    transform: "translate(62.728 29.774)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7315",
    "data-name": "Group 7315",
    clipPath: "url(#clip-path-25)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4387",
    "data-name": "Rectangle 4387",
    width: 2.508,
    height: 1.238,
    transform: "translate(-0.018 2.5) rotate(-89.597)",
    fill: "url(#linear-gradient-24)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7318",
    "data-name": "Group 7318",
    transform: "translate(64.249 30.302)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7317",
    "data-name": "Group 7317",
    clipPath: "url(#clip-path-26)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4388",
    "data-name": "Rectangle 4388",
    width: 1.95,
    height: 0.552,
    transform: "matrix(0.007, -1, 1, 0.007, -0.014, 1.946)",
    fill: "url(#linear-gradient-25)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7320",
    "data-name": "Group 7320",
    transform: "translate(64.249 29.502)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7319",
    "data-name": "Group 7319",
    clipPath: "url(#clip-path-27)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4390",
    "data-name": "Rectangle 4390",
    width: 0.485,
    height: 0.541,
    transform: "matrix(0.007, -1, 1, 0.007, -0.003, 0.481)",
    fill: "url(#linear-gradient-26)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7322",
    "data-name": "Group 7322",
    transform: "translate(114.876 29.502)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7321",
    "data-name": "Group 7321",
    clipPath: "url(#clip-path-28)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4391",
    "data-name": "Rectangle 4391",
    width: 0.485,
    height: 0.541,
    transform: "translate(-0.003 0.481) rotate(-89.597)",
    fill: "url(#linear-gradient-27)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7324",
    "data-name": "Group 7324",
    transform: "translate(65.101 30.256)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7323",
    "data-name": "Group 7323",
    clipPath: "url(#clip-path-29)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4392",
    "data-name": "Rectangle 4392",
    width: 2.004,
    height: 1.766,
    transform: "translate(-0.014 1.992) rotate(-89.596)",
    fill: "url(#linear-gradient-28)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7326",
    "data-name": "Group 7326",
    transform: "translate(67.052 30.256)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7325",
    "data-name": "Group 7325",
    clipPath: "url(#clip-path-30)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4393",
    "data-name": "Rectangle 4393",
    width: 2.788,
    height: 1.905,
    transform: "translate(-0.02 2.774) rotate(-89.596)",
    fill: "url(#linear-gradient-29)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7328",
    "data-name": "Group 7328",
    transform: "translate(70.205 30.256)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7327",
    "data-name": "Group 7327",
    clipPath: "url(#clip-path-31)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4394",
    "data-name": "Rectangle 4394",
    width: 2.049,
    height: 1.771,
    transform: "translate(-0.014 2.037) rotate(-89.597)",
    fill: "url(#linear-gradient-30)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7330",
    "data-name": "Group 7330",
    transform: "translate(73.225 30.256)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7329",
    "data-name": "Group 7329",
    clipPath: "url(#clip-path-32)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4395",
    "data-name": "Rectangle 4395",
    width: 2.049,
    height: 1.807,
    transform: "translate(-0.014 2.037) rotate(-89.596)",
    fill: "url(#linear-gradient-31)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7332",
    "data-name": "Group 7332",
    transform: "translate(75.264 30.256)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7331",
    "data-name": "Group 7331",
    clipPath: "url(#clip-path-33)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4396",
    "data-name": "Rectangle 4396",
    width: 2.05,
    height: 1.939,
    transform: "translate(-0.014 2.037) rotate(-89.597)",
    fill: "url(#linear-gradient-32)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7334",
    "data-name": "Group 7334",
    transform: "translate(77.435 30.301)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7333",
    "data-name": "Group 7333",
    clipPath: "url(#clip-path-34)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4397",
    "data-name": "Rectangle 4397",
    width: 2.004,
    height: 1.742,
    transform: "translate(-0.014 1.991) rotate(-89.597)",
    fill: "url(#linear-gradient-33)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7336",
    "data-name": "Group 7336",
    transform: "translate(80.788 30.256)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7335",
    "data-name": "Group 7335",
    clipPath: "url(#clip-path-35)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4398",
    "data-name": "Rectangle 4398",
    width: 2.049,
    height: 1.731,
    transform: "matrix(0.007, -1, 1, 0.007, -0.014, 2.037)",
    fill: "url(#linear-gradient-34)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7338",
    "data-name": "Group 7338",
    transform: "translate(82.723 30.256)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7337",
    "data-name": "Group 7337",
    clipPath: "url(#clip-path-36)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4399",
    "data-name": "Rectangle 4399",
    width: 2.05,
    height: 1.849,
    transform: "matrix(0.007, -1, 1, 0.007, -0.014, 2.037)",
    fill: "url(#linear-gradient-35)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7340",
    "data-name": "Group 7340",
    transform: "translate(85.607 29.774)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7339",
    "data-name": "Group 7339",
    clipPath: "url(#clip-path-37)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4400",
    "data-name": "Rectangle 4400",
    width: 2.508,
    height: 1.238,
    transform: "translate(-0.018 2.5) rotate(-89.596)",
    fill: "url(#linear-gradient-36)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7342",
    "data-name": "Group 7342",
    transform: "translate(87.01 30.256)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7341",
    "data-name": "Group 7341",
    clipPath: "url(#clip-path-38)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4401",
    "data-name": "Rectangle 4401",
    width: 2.05,
    height: 1.939,
    transform: "translate(-0.014 2.037) rotate(-89.597)",
    fill: "url(#linear-gradient-37)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7344",
    "data-name": "Group 7344",
    transform: "translate(90.107 30.256)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7343",
    "data-name": "Group 7343",
    clipPath: "url(#clip-path-39)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4402",
    "data-name": "Rectangle 4402",
    width: 2.049,
    height: 1.807,
    transform: "matrix(0.007, -1, 1, 0.007, -0.014, 2.037)",
    fill: "url(#linear-gradient-38)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7346",
    "data-name": "Group 7346",
    transform: "translate(92.087 30.256)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7345",
    "data-name": "Group 7345",
    clipPath: "url(#clip-path-40)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4403",
    "data-name": "Rectangle 4403",
    width: 2.049,
    height: 1.771,
    transform: "matrix(0.007, -1, 1, 0.007, -0.014, 2.037)",
    fill: "url(#linear-gradient-39)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7348",
    "data-name": "Group 7348",
    transform: "translate(95.561 29.503)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7347",
    "data-name": "Group 7347",
    clipPath: "url(#clip-path-41)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4404",
    "data-name": "Rectangle 4404",
    width: 2.803,
    height: 1.913,
    transform: "translate(-0.02 2.79) rotate(-89.597)",
    fill: "url(#linear-gradient-40)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7350",
    "data-name": "Group 7350",
    transform: "translate(97.669 30.256)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7349",
    "data-name": "Group 7349",
    clipPath: "url(#clip-path-42)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4405",
    "data-name": "Rectangle 4405",
    width: 2.05,
    height: 1.939,
    transform: "translate(-0.014 2.037) rotate(-89.596)",
    fill: "url(#linear-gradient-41)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7352",
    "data-name": "Group 7352",
    transform: "translate(99.881 30.256)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7351",
    "data-name": "Group 7351",
    clipPath: "url(#clip-path-43)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4406",
    "data-name": "Rectangle 4406",
    width: 2.004,
    height: 1.766,
    transform: "translate(-0.014 1.992) rotate(-89.597)",
    fill: "url(#linear-gradient-42)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7354",
    "data-name": "Group 7354",
    transform: "translate(102.937 30.256)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7353",
    "data-name": "Group 7353",
    clipPath: "url(#clip-path-44)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4407",
    "data-name": "Rectangle 4407",
    width: 2.004,
    height: 1.766,
    transform: "translate(-0.014 1.992) rotate(-89.596)",
    fill: "url(#linear-gradient-43)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7356",
    "data-name": "Group 7356",
    transform: "translate(104.933 30.256)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7355",
    "data-name": "Group 7355",
    clipPath: "url(#clip-path-45)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4408",
    "data-name": "Rectangle 4408",
    width: 2.05,
    height: 1.849,
    transform: "matrix(0.007, -1, 1, 0.007, -0.014, 2.037)",
    fill: "url(#linear-gradient-44)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7358",
    "data-name": "Group 7358",
    transform: "translate(107.022 30.301)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7357",
    "data-name": "Group 7357",
    clipPath: "url(#clip-path-46)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4409",
    "data-name": "Rectangle 4409",
    width: 2.004,
    height: 1.742,
    transform: "translate(-0.014 1.991) rotate(-89.597)",
    fill: "url(#linear-gradient-45)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7360",
    "data-name": "Group 7360",
    transform: "translate(109.091 29.774)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7359",
    "data-name": "Group 7359",
    clipPath: "url(#clip-path-47)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4410",
    "data-name": "Rectangle 4410",
    width: 2.508,
    height: 1.238,
    transform: "matrix(0.007, -1, 1, 0.007, -0.018, 2.5)",
    fill: "url(#linear-gradient-46)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7362",
    "data-name": "Group 7362",
    transform: "translate(111.921 30.256)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7361",
    "data-name": "Group 7361",
    clipPath: "url(#clip-path-48)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4411",
    "data-name": "Rectangle 4411",
    width: 2.049,
    height: 1.771,
    transform: "matrix(0.007, -1, 1, 0.007, -0.014, 2.037)",
    fill: "url(#linear-gradient-47)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7364",
    "data-name": "Group 7364",
    transform: "translate(114.003 29.503)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7363",
    "data-name": "Group 7363",
    clipPath: "url(#clip-path-49)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4412",
    "data-name": "Rectangle 4412",
    width: 2.749,
    height: 0.558,
    transform: "translate(-0.019 2.745) rotate(-89.597)",
    fill: "url(#linear-gradient-48)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7366",
    "data-name": "Group 7366",
    transform: "translate(114.876 30.302)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7365",
    "data-name": "Group 7365",
    clipPath: "url(#clip-path-26)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4414",
    "data-name": "Rectangle 4414",
    width: 1.95,
    height: 0.552,
    transform: "translate(-0.014 1.946) rotate(-89.596)",
    fill: "url(#linear-gradient-49)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7368",
    "data-name": "Group 7368",
    transform: "translate(115.728 29.774)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7367",
    "data-name": "Group 7367",
    clipPath: "url(#clip-path-51)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4416",
    "data-name": "Rectangle 4416",
    width: 2.508,
    height: 1.238,
    transform: "matrix(0.007, -1, 1, 0.007, -0.018, 2.5)",
    fill: "url(#linear-gradient-50)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7370",
    "data-name": "Group 7370",
    transform: "translate(117.134 30.301)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7369",
    "data-name": "Group 7369",
    clipPath: "url(#clip-path-52)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4417",
    "data-name": "Rectangle 4417",
    width: 2.743,
    height: 1.933,
    transform: "matrix(0.007, -1, 1, 0.007, -0.019, 2.729)",
    fill: "url(#linear-gradient-51)"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFull);
export default __webpack_public_path__ + "static/media/logo-full.94a4f226b531bd6c9550cd9cd4ffe80f.svg";
export { ForwardRef as ReactComponent };